Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("../../../styles");
var _reactNative = require("react-native-web");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    input = _STYLES$useStyles.input,
    spacing = _STYLES$useStyles.spacing,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    COLORS = _STYLES$useStyles.COLORS;
  var container = {
    width: '100%'
  };
  var containerText = {
    width: '100%',
    borderRadius: input.borderRadius
  };
  var content = Object.assign({}, input, {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '100%'
  });
  var linkText = Object.assign({}, fontRegular, {
    color: COLORS.cherry,
    marginRight: spacing.l,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var fakeButton = Object.assign({}, fontSemiBold, {
    color: COLORS.cherry,
    textTransform: 'uppercase',
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    containerText: containerText,
    content: content,
    linkText: linkText,
    fakeButton: fakeButton
  });
  return {
    styles: styles
  };
};